import m, { type Component } from 'mithril'
import cloneDeep from 'lodash/cloneDeep'

export function initMithrilComponent<Attrs = Record<string, unknown>, State = Record<string, unknown>>() {
	const component: Component<Attrs, State> = {
		view: () => m('div', 'mitrhil component missing view method'),
	}

	type callable = (attrs: Attrs & m.CommonAttributes<Attrs, State>) => JSX.Element

	return component as unknown as callable & Component<Attrs, State>
}

export function isVnode(obj: m.Vnode | m.Component): obj is m.Vnode {
	return obj != null && typeof obj === 'object' && Object.hasOwn(obj, 'tag')
}

export function passthruComponent(component: m.Vnode | m.Component) {
	return isVnode(component) ? component : m(component)
}

/**
 * Removes the "key" property from an attributes object so that it can be
 * safely spread into nodes
 *
 * @param obj Attributes object
 * @returns Attributes object with "key" property removed
 */
export function getSafePassthruAttrs<T extends Record<string, unknown>>(obj: T): T {
	if (!('key' in obj)) {
		return obj
	}

	// NOTE: not using structuredClone here since it throws an error if an object property is a function
	const cloned_obj = cloneDeep(obj)

	delete cloned_obj.key

	return cloned_obj
}
